import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import './Styles.css'
import { 
  DataGrid, 
  GridFooterContainer, 
  GridPagination, 
  GridToolbar, 
  GridToolbarColumnsButton, 
  GridToolbarContainer, 
  GridToolbarDensitySelector, 
  GridToolbarExport 
} from '@mui/x-data-grid';
import { Box, styled, Typography } from '@mui/material';
import { CONST_SITE_LABEL } from './Helper';

/**
 * Custom Data Grid Table component
 * The component is mainly used in Optimization component
 * @param {*} props 
 * @returns 
 */
const DataGridTableWithCheckbox = (props) => {

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 25
  })

  const columns = props.columns ?? []
  const rows = props.rows ?? []
  const disableMultipleRowSelection = props['disableMultipleRowSelection'] ?? false
  const isServerPagination = props['useServerPagination'] ?? false
  const showCustomToolbar = props['showCustomToolbar'] ?? false
  const headerBgColor = props.headerBgColor ?? '#203B5A'
  const evenRowBgColor = props.evenRowBgColor ?? '#E6EAED'
  const oddRowColor = props.oddRowColor ?? '#000'
  const evenRowColor = props.evenRowColor ?? '#000'
  const iconColor = props.actionIconColor ?? '#2793F2'
  const rowHeight = props.rowHeight ?? null
  const serverPaginationProps = isServerPagination && {
    rowCount: props['paginationLimit']?.['totalCount'] ?? 0,
    paginationMode: "server",
    pageSizeOptions: [props['paginationLimit']?.['pageSize'] ?? 100], // Single option to prevent selection
    paginationModel: {
      pageSize: props['paginationLimit']?.['pageSize'] ?? 100,
      page: (props['paginationLimit']?.['currentPage'] ?? 1) - 1, // Because API responds with first page number to be 1
    },
    onPaginationModelChange: (newPaginationModel) => {
      if (typeof props['onServerPaginationChange'] === 'function') {
        props['onServerPaginationChange'](newPaginationModel)
      }
    }
  };

  const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .MuiDataGrid-row:nth-of-type(odd)': {
      color: oddRowColor
    },
    '& .MuiDataGrid-row:nth-of-type(even)': {
      backgroundColor: evenRowBgColor,
      color: evenRowColor
    },
    '& .MuiButton-text': {
      color: '#000'
    },
    '& .MuiButton-text .MuiSvgIcon-root': {
      color: iconColor
    },
    '& .MuiDataGrid-toolbarContainer': {
      alignSelf: 'end'
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: headerBgColor,
      color: '#fff',
      fontWeight: '600'
    }
  }));

  /**
   * Returns CSV filename
   * @returns 
   */
  const generateExportFileName = () => {
    const path = window.location.pathname
    const splitPath = path.split('/')
    return `${CONST_SITE_LABEL}_${splitPath[splitPath.length - 1]?.toUpperCase()}`
  }

  /**
 * Custom Footer Component
 * @param {*} props 
 * @returns 
 */
  const CustomFooterComponent = (props) => {
    return (
      <GridFooterContainer>
        <div>{props['customFooterEl']}</div>
        <GridPagination />
      </GridFooterContainer>
    )
  }

  const NoRowsOverlay = () => {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
      >
        <Typography variant="h6" color="textSecondary">
          No Data Found
        </Typography>
      </Box>
    );
  }

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
      <GridToolbarExport />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );

  return (
    <Paper style={{ width: '100%' }}>
      <div style={{
        // maxHeight: 440, 
        // minWidth: 400,
        minWidth: 'auto',
        // overflow: 'auto'
      }}>
        <StyledDataGrid
          {...(props.rowHeight !== null && props.rowHeight !== undefined  ? { rowHeight: props.rowHeight }  : {})}
          slots={{
            toolbar: GridToolbar,
            noRowsOverlay: props['subscribeOverlayComponent'] ?? NoRowsOverlay,
            footer: CustomFooterComponent
          }}
          className='optimization-data-grid'
          columns={columns}
          rows={rows}
          slotProps={{
            toolbar: {
              csvOptions: { fileName: generateExportFileName() },
            },
            footer: { customFooterEl: props['customFooterEl'] }
          }}
          checkboxSelection
          rowSelectionModel={[...new Set(props['selectedIDList'])]}
          onRowSelectionModelChange={props['onDataGridCheckboxSelect']}
          disableMultipleRowSelection={disableMultipleRowSelection}
          disableRowSelectionOnClick
          initialState={{
            columns: {
              columnVisibilityModel: props['columnVisibilityModel']
            },
          }}
          paginationModel={isServerPagination ? serverPaginationProps.paginationModel : paginationModel}
          onPaginationModelChange={(newModel) => {
            if (isServerPagination) {
              if (typeof props['onServerPaginationChange'] === 'function') {
                props['onServerPaginationChange'](newModel)
              }
            } else {
              setPaginationModel(newModel)
            }
          }}
          {...(isServerPagination ? {
            rowCount: serverPaginationProps.rowCount,
            paginationMode: serverPaginationProps.paginationMode,
            pageSizeOptions: serverPaginationProps.pageSizeOptions,
          } : {})}
        />
      </div>

    </Paper>
  );
};

export default DataGridTableWithCheckbox;
